import { Suspense } from 'react';
import { OrdersListClient } from './orders-list-client';

export default function Page() {
  return (
    <Suspense fallback={null}>
      <OrdersListClient />
    </Suspense>
  );
}
